<template>
  <div class="trial-surgeons-table">
    <div class="table-container">
      <div class="inner-scroll">
        <table>
          <thead>
            <td v-for="(heading, keyIndex) in headers" :key="keyIndex" >
              {{heading}}
            </td>
          </thead>
          <tbody>
            <tr v-for="(row, rowIndex) in rows" :key="rowIndex" @click="onRowClick(row)" >
              <td v-for="(key, keyIndex) in columns" :key="keyIndex" >
                {{row[key]}}
              </td>
              <td>
                <input type="checkbox" v-model="selected" :id="row.id" :value="row.id" :disabled="row.enrolment_target > 0">
              </td>
              <td>
                <input type="number" min="1" ref="enrolInput" :id="row.id" :disabled="!selected.includes(row.id)" @input="onInput">
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <rp-pagination :pageInfo="pageInfo" @getData="getUsers"/>
    </div>
  </div>
</template>

<script>
  import Pagination from './Pagination.vue'

  export default {
    components: {
      'rp-pagination': Pagination,
    },

    data() {
      return {
        rows: [],
        pageInfo: {
          page_size: 10,
          page_number: 1
        },
        columns: ['name', 'email'],
        headers: ['Name', 'Email', 'Enrol', 'Enrolment Target'],
        selected: [],
      }
    },

    props: {
      surgeonsPage: Object,
      selectedEnrolments: Array,
    },

    methods: {
      getUsers(page) {
        this.$emit('getUsers', page)
      },

      onRowClick(row) {
        this.$emit('onRowClick', row)
      },

      onInput(e) {
        let en = this.selectedEnrolments.find((x) => x.id == e.srcElement.id)
        if (en) {
          en.enrolment_target = e.target.valueAsNumber
        }
      },

      refreshInputs() {
        if (this.$refs["enrolInput"]) {
          for (let el of this.$refs["enrolInput"]) {
            let en = this.selectedEnrolments.find((x) => x.id == el.id) ||
                     this.rows.find((x) => x.id == el.id)
            if (en && en.enrolment_target > 0) {
              el.value = en.enrolment_target
            } else {
              el.value = ''
            }
          }
        }
      },
    },

    watch: {
      surgeonsPage: {
        handler: function(val) {
          this.rows = val.data
          this.pageInfo = val.page
          this.$nextTick(() => {
            this.refreshInputs()
          })
        }
      },

      selected: {
        handler: function(val) {
          // Handle removed
          for (let en of this.selectedEnrolments) {
            if (val.includes(en.id) === false) {
              en.selected = false
            }
          }
          // Handle added
          for (let id of val) {
            let en = this.selectedEnrolments.find((x) => x.id == id)
            if (en === undefined) {
              // Handle new
              this.selectedEnrolments.push({id: id, enrolment_target: 100, selected: true})
              let el = this.$refs["enrolInput"].find((x) => x.id == id)
              if (el && el.value == '') {
                el.value = 100
              }
            } else {
              // Handle existing
              en.selected = true
            }
          }
        }
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import '../../styles/base/variables'
  @import '../../styles/helpers/mixins'
  @import '../../styles/base/themes'

  table
    padding: 10px
    width: 100%
    border-collapse: collapse

    td
      &.tdbutton
        width: 20px

      .status
        display: block

      div
        span
          display: flex
          justify-content: center

  thead
    @include themify($themes)
      background: themed('thead-background')
      color: themed('thead-color')

    font-weight: bold
    text-transform: uppercase
  
    td
      white-space: nowrap
      line-height: 1

      &.tdbutton
        text-align: center

      @include themify($themes)
        padding: themed('thead-td-padding')
        font-weight: themed('thead-td-weight')
        font-size: themed('thead-font-size')
        
      &:first-child 
        @include themify($themes)
          border-radius: themed('td-radius-left')

      &:last-child
        @include themify($themes)
          border-radius: themed('td-radius-right')

  tr
    @include themify($themes)
      border-bottom: themed('tr-border-bottom')
  
    &:first-child
      @include themify($themes)
        border-top: themed('tr-border-top')
    td
      @include themify($themes)
        padding: themed('td-padding')
      
      font-size: 12px
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/TrialSurgeonEnrolTable.vue